import React, { useState } from 'react';
import TextInput from '../InputComponent/TextInput';
import SelectInput from '../InputComponent/SelectInput';
import TextAreaInput from '../InputComponent/TextAreaInput';

const HealthInfoStep = ({ data, onNext, onBack }) => {
    const [formData, setFormData] = useState(data);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if ((name === "height" || name === "weight") && value.length > 3) {
            return;  
        }
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleContinue = () => {
        onNext({ health: formData });
    };

    return (
        <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-800">2. Health Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <TextInput label={"Height (cm)"} type="number" name="height" value={formData.height} onChange={handleChange} />
                <TextInput label={"Weight (kg)"} type="number" name="weight" value={formData.weight} onChange={handleChange} />
                <SelectInput label={'Fitness Level'} name="level" value={formData.level} onChange={handleChange} >
                    <option>Beginner</option>
                    <option>Intermediate</option>
                    <option>Advanced</option>
                </SelectInput>
            </div>
            <TextAreaInput label={"Medical Conditions (if any)"} name="conditions" value={formData.conditions} onChange={handleChange} rows="3" />
            <TextAreaInput label={"Fitness Goals"} name="goals" value={formData.goals} onChange={handleChange} rows="3" />

            <div className="pt-4 flex justify-between">
                <button onClick={onBack} className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Back</button>
                <button onClick={handleContinue} className="px-6 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">Save & Continue</button>
            </div>
        </div>
    );
};

export default HealthInfoStep;
